export const NS_GET_ANALYSIS_THROUGHPUT_DATA =
  'NS_GET_ANALYSIS_THROUGHPUT_DATA';
export const NS_GET_ANALYSIS_THROUGHPUT_DATA_SUCCESS =
  'NS_GET_ANALYSIS_THROUGHPUT_DATA_SUCCESS';
export const NS_GET_ANALYSIS_THROUGHPUT_DATA_FAIL =
  'NS_GET_ANALYSIS_THROUGHPUT_DATA_FAIL';

export function getAnalystThroughputData(payload) {
  return {
    type: NS_GET_ANALYSIS_THROUGHPUT_DATA,
    payload
  };
}

export function getAnalystThroughputDataSuccess(payload) {
  return {
    type: NS_GET_ANALYSIS_THROUGHPUT_DATA_SUCCESS,
    payload
  };
}
